/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

import Vue from 'vue';

/**
 * polyfills
 */
import smoothscroll from 'smoothscroll-polyfill';

import vSelect from 'vue-select';

import SvgIcon from '@/icons';
import FormInput from '@/components/controls/FormInput';
import FormCheckbox from '@/components/controls/FormCheckbox';
import FormSelect from '@/components/controls/FormSelect';
import FormButton from '@/components/controls/FormButton';
import FormSwitch from '@/components/controls/FormSwitch';
import ToastMessage from '@/components/ToastMessage';

import ContactView from '@/views/Contact.vue';

smoothscroll.polyfill();

Vue.prototype.$_GLOBAL = {
  CHAT_ENABLED: true,
  Timers: {
    AUTO_ANSWER_FAV_TIMEOUT: 3000,
    CALL_INFO_DELAY: 3000,
    CALL_INFO_DELAY_SUPER_EASY: 5000,
    CALL_TIMEOUT: 32000,
    INCOMING_CALL_TIMEOUT: 28000,
    MEETING_CONTROLS_HIDE: 10000,
    TOAST_SHORT: 3000,
    TOAST_LONG: 7000
  },
  pipProps: {
    borderWidth: 4,
    borderColor: {
      hex: '#FFFFFF',
      rgb: '255,255,255'
    },
    portrait: {
      width: 14.0,
      height: 24.0,
      top: 4.0,
      left: 2.0,
      aspectRatio: 16 / 9
    },
    landscape: {
      width: 20.0,
      height: 10.0,
      top: 4.0,
      left: 2.0,
      aspectRatio: 9 / 16
    }
  }
};

Vue.component('v-select', vSelect);

Vue.component('SvgIcon', SvgIcon);
Vue.component('FormInput', FormInput);
Vue.component('FormCheckbox', FormCheckbox);
Vue.component('FormSelect', FormSelect);
Vue.component('FormButton', FormButton);
Vue.component('FormSwitch', FormSwitch);
Vue.component('ToastMessage', ToastMessage);

Vue.component('ContactView', ContactView);
